export default __webpack_public_path__ + "static/media/sbo-img.2d4adf1c.webp";